/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SyncEntitySectionPage = lazyLoad(
  () => import('./index'),
  module => module.SyncEntitySectionPage
);
